import { render, staticRenderFns } from "./SendAmount.vue?vue&type=template&id=13ebedac&scoped=true"
import script from "./SendAmount.vue?vue&type=script&lang=js"
export * from "./SendAmount.vue?vue&type=script&lang=js"
import style0 from "./SendAmount.vue?vue&type=style&index=0&id=13ebedac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ebedac",
  null
  
)

export default component.exports